import { Link } from 'react-router-dom';
import { cx } from './utils';

const EXTERNAL_PROTOCOL = /^(?:https?:|mailto:|tel:)/i;

/** A navigation control. Use Button for in-page actions and ButtonLink for navigation. */
export default function ButtonLink({
  children,
  className,
  disabled = false,
  external,
  fullWidth = false,
  size = 'md',
  to,
  variant = 'primary',
  ...props
}) {
  const isExternal = external ?? EXTERNAL_PROTOCOL.test(to || '');
  const classes = cx(
    'ui-button',
    `ui-button--${variant}`,
    `ui-button--${size}`,
    fullWidth && 'ui-button--full',
    className,
  );

  if (!isExternal) {
    return (
      <Link
        {...props}
        to={to}
        className={classes}
        aria-disabled={disabled || undefined}
        tabIndex={disabled ? -1 : props.tabIndex}
        onClick={event => {
          if (disabled) event.preventDefault();
          props.onClick?.(event);
        }}
      >
        {children}
      </Link>
    );
  }

  return (
    <a
      {...props}
      href={to}
      className={classes}
      aria-disabled={disabled || undefined}
      tabIndex={disabled ? -1 : props.tabIndex}
      onClick={event => {
        if (disabled) event.preventDefault();
        props.onClick?.(event);
      }}
    >
      {children}
    </a>
  );
}
